export const CanonicalResellerStatusNames = {
    3: 'Active',
    4: 'Closed'
};

export const CanonicalResellerStatus = {
    ACTIVE: 3,
    CLOSED: 4
};
